$.fn.collapseNav = function(){
  return this.each((i,self)=>{
    $(self).find('.menu-item-has-children').each((i,v)=>{
      const $submenu = $(v).children('ul.sub-menu').addClass('collapse')
      if ($(v).hasClass('current-menu-parent')){
        $submenu.collapse('show')
      }
      $(v).children('a').on('click',function(){
        $submenu.collapse('toggle')
        return false
      })
    })
  })
}